/* eslint @typescript-eslint/no-explicit-any: 0 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import locale from './locale'
import resources from './resources'
import dayjs from 'dayjs'

// set dayjs locale globally, i.e. for antd calendar
dayjs.locale(locale.getPreffered())

// Link yup to i18n
import './yup'

export * from './hooks'

i18n
	.use(LanguageDetector) // detect the browser selected config
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources: Object.keys(resources).reduce(
			(acc, code) => ({
				...acc,
				[code]: resources[code as keyof typeof resources],
			}),
			{}
		),
		lng: locale.getPreffered(),
		fallbackLng: locale.getFallback(),
		load: 'languageOnly',
		debug: process.env.NODE_ENV !== 'production' && typeof window !== 'undefined',
	})

i18n.on('languageChanged', lng => {
	dayjs.locale(lng)
})
